<template>
  <div>
    <section-definition :title="page.title" :extraOptions="page.options" :icon="page.icon"
      :breadcrumbs="page.breadcrumbs" :exportOptions="page.exportOptions" @openFilter="systemcallsummary"
      @refreshPage="refreshReportPage" :isMaterialIconType="true" @exportData="exportReportReport"
      @toggleClick="toggleClick" :style="styleObject"></section-definition>
    <loader v-if="page.loading"></loader>
    <v-container v-else fluid grid-list-xl page>
      <v-data-table :headers="getheaders" :items="systemcallsummary_data" class="elevation-1"
        :pagination.sync="pagination" :total-items="agenttotal" :rows-per-page-items="[5, 10, 25]">
        <template v-slot:items="props" v-if="page.viewing == '1'">
          <tr class="checkEmpty p0" v-for="(date, index) in props.item.date" :key="index">
            <td class="checkEmpty p0">
              {{ date.date }}
            </td>
            <td class="checkEmpty p0">{{ date.count }}</td>
            <td class="checkEmpty p0">{{ date.inbound }}</td>
            <td class="checkEmpty p0">{{ date.outbound }}</td>
            <td class="checkEmpty p0">{{ date.inboundAnswer }}</td>
            <td class="checkEmpty p0">{{ date.outboundAnswer }}</td>
            <td class="checkEmpty p0">{{ date.inboundAbandon }}</td>
            <td class="checkEmpty">{{ date.outboundunAnswer }}</td>
            <td class="checkEmpty">{{ date.inboundanswerpercentage }}</td>
            <td class="checkEmpty">
              {{ date.outboundanswerpercentage }}
            </td>
          </tr>
        </template>
        <template v-slot:items="props" v-else>
          <tr class="checkEmpty p0" v-for="(month, index) in props.item.month" :key="index">
            <td class="checkEmpty p0">{{ month.month }}</td>
            <td class="checkEmpty p0">{{ month.count }}</td>
            <td class="checkEmpty p0">{{ month.inbound }}</td>
            <td class="checkEmpty p0">{{ month.outbound }}</td>
            <td class="checkEmpty p0">{{ month.inboundAnswer }}</td>
            <td class="checkEmpty p0">{{ month.outboundAnswer }}</td>
            <td class="checkEmpty p0">{{ month.inboundAbandon }}</td>
            <td class="checkEmpty">{{ month.outboundunAnswer }}</td>
            <td class="checkEmpty">{{ month.inboundanswerpercentage }}</td>
            <td class="checkEmpty">{{ month.outboundanswerpercentage }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
    <!-- <div>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="1000">
          <pdfexport
            v-if="dialog"
            :header="pdf.header"
            :pdfdata="pdf_data"
            @closeModel="closeModel"
            title="Performance Report"
          ></pdfexport>
        </v-dialog>
      </v-layout>
    </div> -->
    <v-navigation-drawer fixed disable-resize-watcher right :value="page.isFilterOpen" class="filterNavigation">
      <v-toolbar small color="secondary" style="color: white">
        <v-toolbar-title>Filter</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon flat color="white" @click="page.isFilterOpen = false">
          <i class="fas fa-close"></i>
        </v-btn>
      </v-toolbar>
      <div
        class="flex-column justify-sb height-100-exclude-toolbar overflow-auto"
      >
      <v-container class="sidenavContainer">
        <div class="row">
          <v-container class="pa-1">
            <v-menu v-model="page.menu.fromdate" :close-on-content-click="false" full-width max-width="290" small>
              <template v-slot:activator="{ on }">
                <v-text-field :value="appliedfilter.fromdate" label="From Date" readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker color="primary" v-model="appliedfilter.fromdate" @change="page.menu.fromdate = false">
              </v-date-picker>
            </v-menu>
          </v-container>
          <v-container class="pa-1">
            <v-menu v-model="page.menu.todate" :close-on-content-click="false" full-width max-width="290" small>
              <template v-slot:activator="{ on }">
                <v-text-field :value="appliedfilter.todate" label="To Date" readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker color="primary" v-model="appliedfilter.todate" @change="page.menu.todate = false">
              </v-date-picker>
            </v-menu>
          </v-container>
        </div>
      </v-container>
      <v-container row class="sidenavFooter">
        <v-btn flat @click="resetvalue()">Reset</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="getDataFrom()">Filter</v-btn>
      </v-container>
      </div>
    </v-navigation-drawer>
  </div>
</template>
<script>
import loader from "@/components/Widgets/loader";
import { mapGetters } from "vuex";
// import pdfexport from "./Components/pdfexport";
import moment from "moment";
export default {
  components: {
    loader,
    // pdfexport,
  },
  mounted() {
    let scope = this;
    this.page.loading = false;
    this.page.loading = false;
    this.filteragents = JSON.parse(localStorage.getItem("group_users"));
    // this.$store.dispatch("reportuserlist").then(() => {
    //   // this.getDataFromApi();
    //   this.dateformate();
    // });
    this.dateformate();
    setTimeout(
      function () {
        if (
          scope.$store.getters.UserPermissions.indexOf(
            "reports:callsummary:export"
          ) !== -1
        ) {
          scope.page.exportOptions = ["CSV", "Txt(Tab-Delimited)"];
        } else {
          scope.page.exportOptions = [];
        }
      }.bind(scope),
      1
    );
  },
  computed: {
    getheaders: function () {
      if (this.page.viewing == "1") {
        return this.headers1;
      } else {
        return this.headers2;
      }
    },
    ...mapGetters(["systemcallsummary_data", "filters"]),
  },
  data() {
    return {
      styleObject: {
        height: "80px",
        "margin-top": "-8px",
      },
      page: {
        title: "System Call Summary",
        icon: "network_check",
        loading: true,
        materialicon: true,
        isFilterOpen: false,
        playingRecord: false,
        breadcrumbs: [],
        options: { filter: true, refresh: true, toggleButton: true },
        exportOptions: [],

        viewing: "1",
        menu: {
          fromdate: false,
          todate: false,
        },
      },
      payload: {
        from_date: "",
        to_date: "",
        skip: 0,
        take: 0,
        descending: "",
        export: "system_call_summary",
      },
      total: "",
      call_date: "",
      report: "",
      exports: [],
      pdf_data: [],
      excel_data_date: [],
      excel_data_month: [],
      txt_data_date: [],
      txt_data_month: [],
      filteragents: [],
      from_date: "",
      to_date: "",
      dialog: false,
      appliedfilter: {
        fromdate: "",
        todate: "",
        agent: "",
      },
      export_calls: "1",
      pagination: {
        rowsPerPage: 10,
      },
      headers1: [
        {
          text: "Date",
          align: "left",
          sortable: false,
          class: "p0",
          value: "calldate",
        },
        {
          text: "Count",
          align: "left",
          sortable: false,
          class: "p0",
          value: "count",
        },
        {
          text: "Inbound",
          align: "left",
          sortable: false,
          class: "p0",
          value: "inbound",
        },
        {
          text: "Outbound",
          align: "left",
          sortable: false,
          class: "p0",
          value: "outbound",
        },
        {
          text: "Inbound Answer",
          align: "left",
          sortable: false,
          class: "p0",
          value: "inboundAnswer",
        },
        {
          text: "Outbound Answer",
          align: "left",
          sortable: false,
          class: "p0",
          value: "outboundAnswer",
        },
        {
          text: "Inbound Abandon",
          align: "left",
          sortable: false,
          class: "p0",
          value: "inboundabandon",
        },
        {
          text: "Outbound UnAnswer",
          align: "left",
          sortable: false,
          class: "p0",
          value: "outboundunAnswer",
        },
        {
          text: "Inbound Answer%",
          align: "left",
          sortable: false,
          class: "p0",
          value: "inboundanswerpercentage",
        },
        {
          text: "Outbound Answer%",
          align: "left",
          sortable: false,
          class: "p0",
          value: "outboundanswerpercentage",
        },
      ],
      headers2: [
        {
          text: "Month",
          align: "left",
          sortable: false,
          class: "p0",
          value: "calldate",
        },
        {
          text: "Count",
          align: "left",
          sortable: false,
          class: "p0",
          value: "count",
        },
        {
          text: "Inbound",
          align: "left",
          sortable: false,
          class: "p0",
          value: "inbound",
        },
        {
          text: "Outbound",
          align: "left",
          sortable: false,
          class: "p0",
          value: "outbound",
        },
        {
          text: "Inbound Answer",
          align: "left",
          sortable: false,
          class: "p0",
          value: "inboundabandon",
        },
        {
          text: "Outbound Answer",
          align: "left",
          sortable: false,
          class: "p0",
          value: "outboundAnswer",
        },
        {
          text: "Inbound Abandon",
          align: "left",
          sortable: false,
          class: "p0",
          value: "inboundunAnswer",
        },
        {
          text: "Outbound UnAnswer",
          align: "left",
          sortable: false,
          class: "p0",
          value: "outboundunAnswer",
        },
        {
          text: "Inbound Answer%",
          align: "left",
          sortable: false,
          class: "p0",
          value: "inboundanswerpercentage",
        },
        {
          text: "Outbound Answer%",
          align: "left",
          sortable: false,
          class: "p0",
          value: "outboundanswerpercentage",
        },
      ],
      agentperformancereport: [],
      agenttotal: 0,
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
    "appliedfilter.fromdate"(newVal) {
      var from_date = moment(newVal).format("YYYY-MM-DD");
      this.$store.commit("ACTION_FROMDATE", from_date);
      this.$store.commit("FILTERFROMDATE", from_date);
      this.skip = 0;
      // this.getDataFromApi();
    },
    "appliedfilter.todate"(newVal) {
      var to_date = moment(newVal).format("YYYY-MM-DD");
      this.$store.commit("ACTION_TODATE", to_date);
      this.$store.commit("FILTER_TODATE", to_date);
      this.skip = 0;
      // this.getDataFromApi();
    },
    "appliedfilter.agent"(newVal) {
      this.$store.commit("FILTER_AGENT", { agent: newVal });
      this.skip = 0;
      // this.getDataFromApi();
    },
  },
  methods: {
    systemcallsummary: function () {
      this.page.isFilterOpen = true;
    },
    refreshReportPage: function () {
      var scope = this;
      scope.dateformate();
      scope.getDataFromApi();
      scope.refreshvalue();
      scope.appliedfilter.agent = "";
    },
    exportReportReport: function (option) {
      if (option == "PDF" || option == "Txt(Tab-Delimited)") {
        this.dialog = true;
      }
      ``;
      //var export_option = {export_formate : option , viewing : this.page.viewing};
      var export_option = { export_formate: option };
      this.export(export_option);
    },
    toggleClick: function (option) {
      this.page.viewing = option;
    },
    dateformate() {
      this.page.loading = false;
      this.to_date = new Date();
      this.to_date = moment(this.to_date).format("YYYY-MM-DD");
      var from_date1 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 30;
      from_date1.setTime(from_date1.getTime() - dateOffset);
      this.from_date = moment(from_date1).format("YYYY-MM-DD");
      this.appliedfilter.fromdate = this.from_date;
      this.appliedfilter.todate = this.to_date;
      this.$store.commit("FILTERFROMDATE", this.from_date);
      this.$store.commit("FILTER_TODATE", this.to_date);
    },
    getDataFromApi() {
      var scope = this;
      var { descending } = scope.pagination;
      scope.payload.to_date = scope.to_date;
      scope.payload.from_date = scope.from_date;
      var { page, rowsPerPage } = scope.pagination;
      //scope.$store
      //  .dispatch("reportuserlist")
      //  .then((response) => {
      //    let dataa = response.toString(",");
      scope.payload.agent = JSON.parse(localStorage.getItem("group_users"));
      if (rowsPerPage == -1) {
        scope.payload.take = scope.total;
      } else if (
        rowsPerPage != "" &&
        rowsPerPage != undefined &&
        rowsPerPage != null
      ) {
        scope.payload.take = rowsPerPage;
      } else {
        scope.payload.take = 5;
      }
      if (page != "" && page != undefined && page != null) {
        scope.skip = page;
      } else {
        scope.skip = 1;
      }
      scope.payload.skip = (scope.skip - 1) * scope.payload.take;

      scope.payload.descending = descending;

      scope.$store
        .dispatch("systemcallsummary", scope.payload)
        .then((response) => {
          scope.page.loading = false;
          scope.total = response.count;
          if (scope.page_flag) {
            scope.pagination.page = 1;
            scope.page_flag = false;
          }
          scope.agenttotal = scope.total;
          if (response.response.status === 401) {
            scope.$store.dispatch("checkingtoken");
          }
        });
      // });
      //})
    },
    getDataFrom() {
      this.skip = 0;
      this.getDataFromApi();
      this.page_flag = true;
      this.page.isFilterOpen=false
    },
    resetvalue() {
      this.skip = 0;
      var to_date = new Date();
      to_date = moment(to_date).format("YYYY-MM-DD");
      var from_date = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 30;
      from_date.setTime(from_date.getTime() - dateOffset);
      from_date = moment(from_date).format("YYYY-MM-DD");
      this.$store.dispatch("fromdate", from_date);
      this.$store.dispatch("todate", to_date);
      this.appliedfilter.agent = "";
      this.appliedfilter.flag = true;
      this.appliedfilter.fromdate = "";
      this.appliedfilter.todate = "";
      if (this.appliedfilter.flag) {
        this.appliedfilter.fromdate = from_date;
        this.appliedfilter.todate = to_date;
        this.appliedfilter.flag = false;
      }
      this.page.isFilterOpen = false;
      this.getDataFromApi();
    },
    closeModel: function () {
      this.dialog = false;
    },

    export(option) {

      this.excel_data_date = [];
      this.excel_data_month = [];
      this.txt_data_date = [];
      this.txt_data_month = [];
      // this.pdf_data = [];
      var from_date = moment(this.payload.from_date).format("YYYY-MM-DD");
      var to_date = moment(this.payload.to_date).format("YYYY-MM-DD");
      var export_date = {
        from_date: from_date,
        to_date: to_date,
        skip: this.payload.skip,
        take: this.payload.take,
        misseddetail: "system_call_summary",
      };

      this.$store.dispatch("exportdatafetch", export_date).then((response) => {
        this.exports = response;
        this.excel_data_date = response[0].date;
        this.excel_data_month = response[0].month;
        this.txt_data_date = response[0].date;
        this.txt_data_month = response[0].month;


        if (option.export_formate == "CSV" && this.page.viewing === "1") {

          let csvContent = "data:text/csv;charset=utf-8,\uFEFF";

          csvContent += Object.keys(this.excel_data_date[0]).join(",") + "\r\n";

          this.excel_data_date.forEach(function (rows) {
            let data = Object.values(rows);
            let data1 = [];
            data.forEach((elm) => {
              if (typeof elm === "string") {
                data1.push(elm.replace(/'|"|#|\n/g, " "));
              } else {
                data1.push(elm);
              }
            });
            let row = data1.join(",");
            csvContent += row + "\r\n";
          });
          let date = new Date();
          date = moment(date).format("YYYY-MM-DD hh-mm");
          let encodedUri = encodeURI(csvContent);
          let link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute(
            "download",
            "Call_Summary" + date + ".csv"
          );
          document.body.appendChild(link);
          link.click();
        }
        if (option.export_formate == "CSV" && this.page.viewing === "2") {
          let csvContent = "data:text/csv;charset=utf-8,\uFEFF";
          csvContent += Object.keys(this.excel_data_month[0]).join(",") + "\r\n";
          this.excel_data_month.forEach(function (rows) {
            let data = Object.values(rows);
            let data1 = [];
            data.forEach((elm) => {
              if (typeof elm === "string") {
                data1.push(elm.replace(/'|"|#|\n/g, " "));
              } else {
                data1.push(elm);
              }
            });
            for (let i = 0; i < data1.length; i++) {
              if (
                data1[i] != null &&
                data1[i] != undefined &&
                data1[i] != "" && typeof data1[i] == "string"
              ) {
                if (data1[i].includes(",")) {
                  data1[i] = data1[i].replaceAll(",", ";");
                }
              }
            }
            let row = data1.join(",");
            csvContent += row + "\r\n";
          });
            var date = new Date();
          date = moment(date).format("YYYY-MM-DD hh-mm");
          const encodedUri =
            "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);
          const link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", "calldetails_" + date + ".csv");
          document.body.appendChild(link); // Required for FF
          link.click();
        }
        if (option.export_formate == "Txt(Tab-Delimited)" && this.page.viewing === "1") {
          let txtContent = "";
          let txt_key = Object.keys(this.txt_data_date[0]);
          let txt_tab = txt_key.join("\t");
          txtContent += `${txt_tab} \r\n`;
          this.txt_data_date.forEach(function (rows) {
            let data = Object.values(rows);
            let row = data.join("\t");
            txtContent += row + "\r\n";
          });
          var date2 = new Date();
          date2 = moment(date2).format("YYYY-MM-DD hh-mm");
          var encodedUri1 =
            "data:text/plain;charset=utf-8,\uFEFF" +
            encodeURIComponent(txtContent);

          var link1 = document.createElement("a");
          link1.setAttribute("href", encodedUri1);
          link1.setAttribute(
            "download",
            "callSummary" + date2 + ".txt"
          );
          document.body.appendChild(link1);
          link1.click();
        }
        if (option.export_formate == "Txt(Tab-Delimited)" && this.page.viewing === "2") {
          let txtContent = "";
          let txt_key = Object.keys(this.txt_data_month[0]);
          let txt_tab = txt_key.join("\t");
          txtContent += `${txt_tab} \r\n`;
          this.txt_data_month.forEach(function (rows) {
            let data = Object.values(rows);
            let row = data.join("\t");
            txtContent += row + "\r\n";
          });
          let date2 = new Date();
          date2 = moment(date2).format("YYYY-MM-DD hh-mm");
          let encodedUri1 =
            "data:text/plain;charset=utf-8,\uFEFF" +
            encodeURIComponent(txtContent);

          let link1 = document.createElement("a");
          link1.setAttribute("href", encodedUri1);
          link1.setAttribute(
            "download",
            "callSummary" + date2 + ".txt"
          );
          document.body.appendChild(link1);
          link1.click();
        }
      });
    },
    refreshvalue() {
      this.$store.commit("FILTER_AGENT", { agent: "" });
      this.page_flag = true;
    },
  },

  beforeDestroy() {
    this.$store.commit("FILTER_AGENT", { agent: "" });
  },
};
</script>
<style>
  .icons {
    height: 80px;
  }
  </style>